import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor() { }

  cleanString(data) {
    const specialChars = [
    /[\300-\306]/g, /[\340-\346]/g, // À, Á, Â, Ã, Ä, Å, Æ, à, á, â, ã, ä, å, æ
    /[\310-\313]/g, /[\350-\353]/g, // È, É, Ê, Ë, è, é, ê, ë
    /[\314-\317]/g, /[\354-\357]/g, // Ì, Í, Î, Ï, ì, í, î, ï
    /[\322-\330]/g, /[\362-\370]/g, // Ò, Ó, Ô, Õ, Ö, Ø, ò, ó, ô, õ, ö, ø
    /[\331-\334]/g, /[\371-\374]/g, // Ù, Ú, Û, Ü, ù, ú, û, ü
    /[\307]/g, /[\347]/g, /[\337]/g, // Ç, ç, ß
    /[Ñ]/g, /[ñ]/g // Ñ, ñ
    ];
    const noSpecialChars = ['A', 'a', 'E', 'e', 'I', 'i', 'O', 'o', 'U', 'u', 'C', 'c', 's', 'N', 'n'];

    const length = specialChars.length;
    for (let i = 0; i < length; i++) {
      data = data.replace(specialChars[i], noSpecialChars[i]);
    }

    return data;
  }

  diffHours(dt2, dt1) {
    if (dt2 && dt1) {
      let diff = (dt2.getTime() - dt1.getTime()) / 1000;
      diff /= (60 * 60);
      return (Math.abs(Math.round(diff * 100) / 100));
    }
  }

  /** ********************************
   * COMPARATORS
  ******************************** */

  compareItemByFullField(a: any, b: any): number {
    const aFullField = a.campoCompleto.trim();
    const bFullField = b.campoCompleto.trim();
    return aFullField.localeCompare(bFullField);
  }

  compareEmployeeByName(a: any, b: any): number {
    if (a && b) {
      const aFullName = a.nameEmployee.trim() + ' ' + a.surnamesEmployee.trim();
      const bFullName = b.nameEmployee.trim() + ' ' + b.surnamesEmployee.trim();
      return aFullName.localeCompare(bFullName);
    }
  }

  compareClientByName(a: any, b: any): number {
    if (a && b) {
      const aName = a.nameClient.trim();
      const bName = b.nameClient.trim();
      return aName.localeCompare(bName);
    }
  }

  compareProjectByDescription(a: any, b: any): number {
    if (a && b) {
      const aDescription = a.description.trim();
      const bDescription = b.description.trim();
      return aDescription.localeCompare(bDescription);
    }
  }

  /**
   * Order an array using the name of property that it pass as a parameter
   * @param array data to order
   * @param nameOfPropertyToOrder proprty to consider to order the array
   * @param type indicating the type of order (ASC or DESC)
   * @returns new array ordered
   */
  orderByAlphabetically(array: Array<any>, nameOfPropertyToOrder: string, type?: string): Array<any> {
    if (!array || array.length === 0 || !nameOfPropertyToOrder) {
      return;
    }
    let orderedArray = array;
    if (!type || (type && type === 'ASC')) {
      orderedArray = array.sort((a, b) => {
        if (a[nameOfPropertyToOrder].toLowerCase() > b[nameOfPropertyToOrder].toLowerCase()) {
          return 1;
        } else if (a[nameOfPropertyToOrder].toLowerCase() < b[nameOfPropertyToOrder].toLowerCase()) {
          return -1;
        } else {
          return 0;
        }
      });
    } else if (type && type === 'DESC') {
      orderedArray = array.sort((a, b) => {
        if (a[nameOfPropertyToOrder].toLowerCase() < b[nameOfPropertyToOrder].toLowerCase()) {
          return 1;
        } else if (a[nameOfPropertyToOrder].toLowerCase() > b[nameOfPropertyToOrder].toLowerCase()) {
          return -1;
        } else {
          return 0;
        }
      });
    }
    return orderedArray;
  }
  /**
   * Order an array using the name of property that it pass as a parameter
   * @param array data to order
   * @param nameOfPropertyToOrder proprty to consider to order the array (boolean variable)
   * @param type indicating the type of order (ASC or DESC)
   * @returns new array ordered
   */
  orderByBoolean(array: Array<any>, nameOfPropertyToOrder: string, type?: string): Array<any> {
    if (!array || array.length === 0 || !nameOfPropertyToOrder) {
      return;
    }
    let orderedArray = array;
    if (!type || (type && type === 'ASC')) {
      const listTrue = array.filter(item => item[nameOfPropertyToOrder] === true);
      const listFalse = array.filter(item => item[nameOfPropertyToOrder] === false);
      orderedArray = listTrue.concat(listFalse);
    } else if (type && type === 'DESC') {
      const listTrue = array.filter(item => item[nameOfPropertyToOrder] === true);
      const listFalse = array.filter(item => item[nameOfPropertyToOrder] === false);
      orderedArray = listFalse.concat(listTrue);
    }
    return orderedArray;
  }

  formatDateToSendToBackend(value: any): string {
    const date = new Date(value);
    const trashMonth = date.getMonth() + 1 ;
    const month = trashMonth < 10 ? '0' + trashMonth : trashMonth;
    const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    return `${date.getFullYear()}${month}${day}`;
  }

  /*
   Remove not provided dates from objects because backend not accepts null / undefined or empty strings as date
  */
  deleteNotNeededDates(data: any): void {
    if (
      data.endDate === null ||
      data.endDate === undefined
    ) {
      delete data.endDate;
    }

    if (
      data.endDateEmployee === '' ||
      data.endDateEmployee === null ||
      data.endDateEmployee === undefined
    ) {
      delete data.endDateEmployee;
    }

    if (
      data.datEmpJorFechaInicio === '' ||
      data.datEmpJorFechaInicio === null ||
      data.datEmpJorFechaInicio === undefined
    ) {
      delete data.datEmpJorFechaInicio;
    }

    if (
      data.datEmpcatFechainicio === '' ||
      data.datEmpcatFechainicio === null ||
      data.datEmpcatFechainicio === undefined
    ) {
      delete data.datEmpcatFechainicio;
    }

    if (
      data.birthEmployee === '' ||
      data.birthEmployee === null ||
      data.birthEmployee === undefined
    ) {
      delete data.birthEmployee;
    }

    if (
      data.datEmpJorFechaInicio === '' ||
      data.datEmpJorFechaInicio === null ||
      data.datEmpJorFechaInicio === undefined
    ) {
      delete data.datEmpJorFechaInicio;
    }

    if (
      data.datEmpcatFechainicio === '' ||
      data.datEmpcatFechainicio === null ||
      data.datEmpcatFechainicio === undefined
    ) {
      delete data.datEmpcatFechainicio;
    }
  }

  /**
   * Function to clean a input number to not permit number with greater length and empty values
   * @param value String or number with the value
   */
  cleanInputNumber(value: string): string {
    const MAX_VALUE = 999999.99;
    const MIN_VALUE = -999999.99;
    let res = '0.00';

    if (value === '') {
      res = String((0).toFixed(2));
    } else {
      let resNumber = parseFloat(value) > MAX_VALUE ? MAX_VALUE : parseFloat(value);
      resNumber = resNumber < MIN_VALUE ? MIN_VALUE : resNumber;
      res = resNumber.toFixed(2);
    }
    return res;
  }
}
